define('views/components/periodic_license/periodic_license',['require','backbone','context/basket','models/basket_product','text!templates/components/periodic_license/periodic_license.html'],function(require){

    var Backbone = require('backbone');
    var Basket = require('context/basket');
    var BasketProductModel = require('models/basket_product');

    var temp = require("text!templates/components/periodic_license/periodic_license.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'customer-product-item periodic-license',

        initialize: function() {
            // Add expired class if license expired
            if (this.model.get('end_time') && new Date(this.model.get('end_time')) < new Date()) {
                this.$el.addClass('bg-danger-light');
            } else if (this.model.get('end_time') &&
                (new Date(this.model.get('end_time')).getTime() - new Date().getTime() < 1000*60*60*24*3)) {
                this.$el.addClass('bg-warning-light');
            }
        },

        ui: function() {
            return {
                extendButton: '#extend-button',
                notExtendButton: '#not-extend-button'
            };
        },

        events: {
            'click @ui.extendButton': 'extendButtonClicked',
            'click @ui.notExtendButton': 'notExtendButtonClicked'
        },

        extendButtonClicked: function () {
            var _this = this;

            // Add product to basket, if not exists
            if (App.context.basket.get('products').filter(function (basketProduct) {
                return basketProduct.license === _this.model.get('id');
            }).length === 0) {
                var basketProduct = new BasketProductModel({
                    product: this.model.get('product'),
                    count: 1,
                    license: this.model.get('id')
                });
                App.context.basket.get('products').push(basketProduct.attributes);

                // Show success message
                App.utils.showMessage('success', App.polyglot.t('add_to_basket_success'));
            } else {
                // Already in basket
                App.utils.showMessage('warning', App.polyglot.t('already_in_basket'));
            }
        },


        notExtendButtonClicked: function(){
            var _this = this;

            // Open confirm modal
            App.utils.showConfirmModal(App.polyglot.t('not_extend_message'), function(){
                _this.notExtend();
            });   
        },

        notExtend: function(){
            // If user confirm not extend selected license
            var _this = this;
            $.ajax({
                url: App.Config.apiBase + 'customer-licenses/' + this.model.get('id') + '/not_extend/',
                method: 'post',
                success: function () {
                    // rerender product license view 
                    _this.model.collection.fetch();
                    _this.render();


                    App.utils.showMessage('success', App.polyglot.t('not_extend_success'));
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // Show error messages
                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                        }
                    }else{
                        // Unknown error
                        App.utils.showMessage('error', App.polyglot.t('not_extend_error'));

                    }
                }
            });
        }
    });
});
